// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"78ce91f1","764":"112bd519","884":"f215a4bf"}[chunkId] + ".chunk.js";
};